import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData_Jupiter from "../NoData_Jupiter";
import ChartLoader_Jupiter from "../ChartLoader_Jupiter";
import BuketsTableVehicle_Jupiter from "../BuketsTableVehicle_Jupiter";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import WaterMark from "../../DashboardMain_Jupiter/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { Bar, getElementAtEvent } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  scales
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
let Maxchartdata = []

export default function OBCMaxTempVehicle_Jupiter({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [filteredData, SetfilteredData] = useState([]);
  let barcolor = "#348393"
  let toPush = [];

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "<20": { per: 0, count: 0 },
      "30": { per: 0, count: 0 },
      "40": { per: 0, count: 0 },
      "50": { per: 0, count: 0 },
      "60": { per: 0, count: 0 },
      "70": { per: 0, count: 0 },
      "80": { per: 0, count: 0 },
      "90": { per: 0, count: 0 },
      ">=90": { per: 0, count: 0 }
    };
    if (res_result.length === 0) {
      setChartData((prestate) => []);
    }
    if (res_result.length != 0) {
      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val.OBCMT_20.value > 0) {
          responce["<20"] = { per: parseInt(t_val.OBCMT_20.value * 100), sum: parseInt(t_val.OBCMT_20.value) };
        }
        if (t_val.OBCMT_20_30.value > 0) {
          responce["30"] = { per: parseInt(t_val.OBCMT_20_30.value * 100), sum: parseInt(t_val.OBCMT_20_30.value) };
        }
        if (t_val.OBCMT_30_40.value > 0) {
          responce["40"] = { per: parseInt(t_val.OBCMT_30_40.value * 100), sum: parseInt(t_val.OBCMT_30_40.value) };
        }
        if (t_val.OBCMT_40_50.value > 0) {
          responce["50"] = { per: parseInt(t_val.OBCMT_40_50.value * 100), sum: parseInt(t_val.OBCMT_40_50.value) };
        }
        if (t_val.OBCMT_50_60.value > 0) {
          responce["60"] = { per: parseInt(t_val.OBCMT_50_60.value * 100), sum: parseInt(t_val.OBCMT_50_60.value) };
        }
        if (t_val.OBCMT_60_70.value > 0) {
          responce["70"] = { per: parseInt(t_val.OBCMT_60_70.value * 100), sum: parseInt(t_val.OBCMT_60_70.value) };
        }
        if (t_val.OBCMT_70_80.value > 0) {
          responce["80"] = { per: parseInt(t_val.OBCMT_70_80.value * 100), sum: parseInt(t_val.OBCMT_70_80.value) };
        }
        if (t_val.OBCMT_80_90.value > 0) {
          responce["90"] = { per: parseInt(t_val.OBCMT_80_90.value * 100), sum: parseInt(t_val.OBCMT_80_90.value) };
        }
        if (t_val.greater_90.value > 0) {
          responce[">=90"] = { per: parseInt(t_val.greater_90.value * 100), sum: parseInt(t_val.greater_90.value) };
        }
        toPush.push(t_val.OBCMT_80_90.value)
        toPush.push(t_val.greater_90.value)
        toPush.push(t_val.OBCMT_20.value)
        toPush.push(t_val.OBCMT_20_30.value)
        toPush.push(t_val.OBCMT_30_40.value)
        toPush.push(t_val.OBCMT_40_50.value)
        toPush.push(t_val.OBCMT_50_60.value)
        toPush.push(t_val.OBCMT_60_70.value)
        toPush.push(t_val.OBCMT_70_80.value)
        SetfilteredData(toPush)

        let res_result_final = [["Element", "Count", { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys = ["<20", "30", "40", "50", "60", "70", "80", "90", ">=90"]
        let responce1 = []
        loop_keys.map(x => {
          if (x != "doc_count") {
            res_result_final.push([x, responce[x].sum, `{stroke-width: 1;stroke-color: black;color:${barcolor}}`]);
            responce1.push(responce[x].sum)
          }

          const labels = ["<20", "30", "40", "50", "60", "70", "80", "90", ">=90"]
          Maxchartdata = {
            labels,
            datasets: [
              {
                label: "OBC max temperature (Deg cel)",
                data: responce1,
                backgroundColor: barcolor,
                borderWidth: 1,
                borderColor: "black",
              },
            ]
          };
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }
  const options1 = {
    responsive: true,
    categoryPercentage: 1.0,
    barPercentage: 1.0,
    scales: {
      x: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'OBC max temperature (Deg cel)'
        },
        suggestedMin: 0
      },

      y: {
        grid: {
          color: 'white',
        },
        title: {
          display: true,
          text: 'Charging Cycles'
        },
        suggestedMin: 0,
      },
    },

    plugins: {
      legend: {
        display: false
      },
    }
  }

  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: 'OBC max temperature (Deg cel)',
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: 'Charging Cycles',
      minValue: 0,
      format: '#\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
  };

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/" + apiend, body: { filterdata: gloablfilter } }, appyData)
  }, [gloablfilter])

  const appyDataClick = (data) => {
    let hits = data;
    hits.map((i, key) => {
      toPush.push(i.fields.OBC_max_Temp[0])
    })
    SetfilteredData(toPush.sort())
  }

  const chartEvents = [
    {
      eventName: "select",
      callback({ chartWrapper }) {
        const chart = chartWrapper.getChart()
        const selection = chart.getSelection()
        const [selectedItem] = selection;
        const { row } = selectedItem;
        const barvalue = (chartWrapper.getDataTable().Wf[row].c[0].v);
        let from_bucket;
        let to_bucket;
        if (barvalue === "<20") {
          from_bucket = 0
          to_bucket = 20
        } else if (barvalue === ">=90") {
          from_bucket = 90
          to_bucket = null
        } else {
          from_bucket = barvalue - 10
          to_bucket = barvalue
        }
        fetchData({ url: API_URL_MAIN + "chargingpage_api_jupiter/OBC_vehicle_click", body: { filterdata: gloablfilter, type: "Slow", from_bucket: from_bucket, to_bucket: to_bucket } }, appyDataClick)
        window.$('#exampleModal__' + apiend).modal('show');
      }
    }
  ];

  return (
    <>
      <div className="modal fade" id={apiend + "_modal"} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">OBC max temperature - Slow chrg</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body d-flex justify-content-center" style={{ height: "400px" }}>
              {
                (isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length === 0) ? <NoData_Jupiter /> :
                  <Bar options={options1} data={Maxchartdata} width="100%" height="65px" />
                )}
            </div>
          </div>
        </div>
      </div>

      <strong className="Zoom_first_page d-flex justify-content-end" style={{ cursor: "pointer" }} data-bs-toggle="modal" data-bs-target={"#" + apiend + "_modal"} > <BsZoomIn /> </strong>

      <div className="v-title">
        <div className="chartHGT">
          <WaterMark />
          {(isLoading) ? <ChartLoader_Jupiter /> : ((chartdata.length == 0) ? <NoData_Jupiter /> : <Chart chartType="ColumnChart" width="100%" height="230px" data={chartdata} options={options} chartEvents={chartEvents} />)}
        </div>
      </div>

      <div className="modal fade" id={"exampleModal__" + apiend} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">OBC max temperature</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body" style={{ overflowY: 'scroll', height: '250px' }}>
              <table className="table table-striped">
                <thead style={{ backgroundColor: '#32879c', color: '#fff' }}>
                  <tr>
                    <th scope="col">value</th>
                  </tr></thead>
                <tbody>
                  <BuketsTableVehicle_Jupiter data={filteredData} />
                </tbody></table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
